import { setVis } from "../../../helpers/setVis";
import { changeObjColor } from "../../changeMaterialColor";
import { cloneObject } from "../../cloneObject";
import { hideAndRemove, showHideChildrenByNames } from "../helpers";

// Можно добавить несколько объектов, удаляем только конкретный
export function toggleMultiSceneObject({
    allObjects,
    activeArray,
    name,
    isChecked,
    valueType,
    position = {},
    userData = {},
    excludes = [],
}) {
    for (let i = activeArray.length - 1; i >= 0; i--) {
        if (activeArray[i].name.includes(valueType)) {
            hideAndRemove(activeArray[i]);
            activeArray.splice(i, 1);
        }
    }
    let newObj = null;
    if (isChecked) {
        let obj = null;
        allObjects.forEach((el) => {
            if (el.name === name && !excludes.some((substr) => el.name.includes(substr))) {
                obj = el;
            } else if (el.name.includes(name) && !excludes.some((substr) => el.name.includes(substr)) && !obj) {
                obj = el;
            }
        });
        if (!obj) {
            console.warn("Объект для клонирования не найден", name);
            return;
        }
        newObj = cloneObject(obj);
        Object.assign(newObj.position, position);
        newObj.userData = { ...newObj.userData, ...userData };
        activeArray.push(newObj);
        servObj.scene.add(newObj);
        setVis(newObj, true);
        changeObjColor(activeArray);
    }

    if (userData.verticalOnly) {
        const compareKeys = userData.inputCount ? ["type", "name", "inputCount"] : ["type", "name"];
        const newUserData = userData;
        servObj.building._vertical_only = servObj.building._vertical_only.filter((el) => {
            // Если хотя бы один из ключей отсутствует — не удаляем элемент
            if (compareKeys.some((key) => el.userData[key] === undefined || newUserData[key] === undefined)) {
                return true;
            }
            // Если все ключи совпадают — удаляем элемент
            return !compareKeys.every((key) => el.userData[key] === newUserData[key]);
        });
        if (isChecked && newObj) {
            servObj.building.addVerticalObj(newObj);

            servObj.building.restoreObjectColor();
            setTimeout(() => {
                servObj.building.checkCollision();
                !newObj.userData.isIntersect && servObj.building.coloringObject(newObj, servObj.building.blueColor);
            }, 0);
        }
        if (!isChecked) {
            setTimeout(() => {
                servObj.building.checkCollision();
            }, 100);
        }
    }

    showHideChildrenByNames(newObj, ["hitbox"], false);
}
